"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Federation = void 0;
const generic_entity_1 = require("../../../abstracts/generic-entity");
class Federation extends generic_entity_1.Entity {
    constructor(client, debug) {
        super(client, debug);
    }
    async list() {
        const response = await this.parentEntity.getHttpClient().get('/federation/connection', { headers: this.getHeaders() });
        return response.data;
    }
    async get(id) {
        const response = await this.parentEntity.getHttpClient().get(`/federation/connection/${id}`, { headers: this.getHeaders() });
        return response.data;
    }
    async create(args) {
        const response = await this.parentEntity.getHttpClient().post(`/federation/connection`, args, { headers: this.getHeaders() });
        return response.data;
    }
    async update(id, args) {
        const response = await this.parentEntity.getHttpClient().put(`/federation/connection/${id}`, args, { headers: this.getHeaders() });
        return response.data;
    }
    async delete(id) {
        await this.parentEntity.getHttpClient().delete(`/federation/connection/${id}`, { headers: this.getHeaders() });
    }
}
exports.Federation = Federation;
